module.exports = __webpack_public_path__ + "img/stiker_received.371c0068.png";